import { Button } from "flowbite-react";
import { useNavigate } from "react-router-dom";

const HeroSection = () => {
  const navigate = useNavigate();

  return (
    <div className="mx-auto max-w-2xl py-24 text-center">
      <h1 className="text-5xl font-bold tracking-tight text-gray-900 sm:text-7xl">
        Transforme seu atendimento com a Vintree
      </h1>
      <p className="mt-8 text-lg leading-8 text-gray-800">
        Uma vitrine virtual que economiza tempo e aumenta suas vendas,
        facilitando o atendimento de clientes e organizando fotos de produtos de
        forma prática e atraente.
      </p>
      <div className="mt-10 flex items-center justify-center gap-x-6">
        <Button
          size="lg"
          pill
          onClick={() => navigate("/cadastrar")}
          className="bg-black text-white hover:bg-gray-800"
        >
          Criar minha Vintree grátis
        </Button>
        <Button
          size="lg"
          pill
          gradientDuoTone="pinkToOrange"
          onClick={() => navigate("/entrar")}
        >
          Entrar
        </Button>
      </div>
    </div>
  );
};

export default HeroSection;
